import { onScopeDispose, watch } from 'vue';
import { startLegacyWait, stopLegacyWait } from '@/iframe/legacyLoader';

let instances = 0;

/**
 * Show the application loader (EcosShelfProgress over the whole app, App.vue, #23635) while `busy` is true.
 * Each caller gets a named wait of its own in legacyLoader.js, so a Vue screen waits with the same shelf as the
 * legacy views, never stacks a second loader on theirs, and only ends its own wait. In a template, use the tag
 * <AppLoader :visible="busy" /> (src/components/common/AppLoader.vue), which calls this.
 *
 * @param {import('vue').WatchSource<boolean>} busy - a ref or getter, e.g. () => isLoading.value
 */
export function useAppLoader(busy) {
	const key = `vue-${++instances}`;
	watch(busy, (isBusy) => (isBusy ? startLegacyWait(key) : stopLegacyWait(key)), { immediate: true });
	onScopeDispose(() => stopLegacyWait(key));
}
